import app from '../app.first';

app.AdminMolly = class extends app.Component {
	onReady($this) {
		let prompt = $('#prompt');
		let chatList = $('#chatList');
		let bSendPrompt = $('#bSendPrompt');

		let prompts = [];

		bSendPrompt.on('click', function () {
			$(this).sendMessage()
		})

		$.fn.sendMessage = function () {

			prompts.push({
				'role': 'user',
				'content': prompt.val()
			});

			$(this).realoadChat()

			if (prompt.length > 0) {
				$.ajax({
					url: "/admin/molly/message",
					data: { 'prompts': prompts },
					dataType: 'json',
					cache: false,
					method: 'POST',
					beforeSend: (xhr) => {
						xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
					},
					success: function (response) {
						const data = response.response.data
						console.log(data)
						if (data.choices) {
							prompts.push(
								{
									'role': data.choices[0].message.role,
									'content': data.choices[0].message.content
								}
							)

							$(this).realoadChat()
						}
					},
				});
			}
		}

		$.fn.realoadChat = function () {
			prompt.val('')
			chatList.html('')
			let content = '';
			for (const item of prompts) {
				const chatBoxClass = (item.role === 'user') ? 'incoming' : 'outgoing';
				content  = $(this).formatString(item.content)

				console.log(content);

				chatList.append(`
								<div class="message ${chatBoxClass}">
									<div class="user-icon"><i class="fas fa-user"></i></div>
									<div class="content">${content}.</div>
								</div>
							`)
			}
		}

		$.fn.formatString = function (str) {
			// Replace \n\n with <br>
			str = str.replace(/\n/g, '<br>');
			// Replace markdown links with anchore tags
			str = str.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');

			return str;
		}
	}
}
